// import axios from 'axios';

export const BASE_API_URL = 'http://localhost:3004';
// export const BASE_API_URL = 'https://konnectdiagnostics.com/api';

export default BASE_API_URL;